import {ScreenTracker} from '../../../../utils/ScreenTracker';
import {LocalStorage} from '../../../../utils/LocalStorage';
import {DASHBO_WHATSAPP_URL} from '../../../../settings/settings';
import {SupportChatService} from '../../../support_chat/SupportChatService';
import {NS} from './subscriptionPageModel';

/**
 * Los pedidos de la vista de Suscripción salen por el chat de soporte, ya escritos (D-2): la persona los
 * lee y los envía ella. No se cobra nada dentro de la app.
 *
 * Si el chat no cargó, el pedido sale por WhatsApp, como «Extender la prueba» y el cupo de cuentas de UD-15:
 * `showNewMessage` caería a Intercom, que está apagado, y el botón no haría nada. Por WhatsApp llega de un
 * número desconocido, así que el texto lleva el número de agencia.
 */
export function openSupportRequest(t, message) {
    if (SupportChatService.isEnabled()) {
        SupportChatService.openWithMessage(message);
        return;
    }
    const agencyId = LocalStorage.fetchAgencyId();
    const text = agencyId
        ? t(`${NS}.chat.whatsapp`, {message, agencyId, interpolation: {escapeValue: false}})
        : message;
    window.open(`${DASHBO_WHATSAPP_URL}?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
}

/** «Escribirnos por el chat», sin texto. */
export function openSupportChat() {
    if (SupportChatService.isEnabled()) {
        SupportChatService.openPanel();
        return;
    }
    window.open(DASHBO_WHATSAPP_URL, '_blank', 'noopener,noreferrer');
}

/** Los eventos de la pantalla (contrato §6): `subscription_<qué>`. */
export function recordSubscriptionEvent(name) {
    ScreenTracker.recordEvent(`subscription_${name}`);
}
